export default "__VITE_ASSET__Do_l45O6__"